<div class="component-wrapper">
    <div class="mail-icon-wrapper">
        <i class="mail-icon" alt="Mail logo"></i>
    </div>
    <div class="confirmtext">
        <h2 class="title" *ngIf="email">{{ 'mail.confirmtext1' | translate:{ email } }}</h2>
        <h2 class="title" *ngIf="!email" translate>mail.confirmtext2</h2>    
        <p class="message">{{ message }}</p>
    </div>
</div>